import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import DashboardHeader from '../../pages/acv-home/components/HeaderACV';
import OrizonFooter from '../../pages/acv-home/components/OrizonFooter';
import { ToastProvider } from '../orizon-ui/Toast';
import { ConfirmProvider } from '../orizon-ui/ConfirmDialog';
import { sbloccaTuttoLoScroll } from '../orizon-ui/scrollLock';

/**
 * Ljuska di tutte le pagine GRU: header e footer condivisi con il resto dell'app,
 * contenitore con gli stessi margini delle pagine CCO, pulsanti Indietro / Dashboard,
 * e provider per Toast e ConfirmDialog.
 * indietroA: percorso per "Indietro" (se omesso torna alla pagina precedente).
 */
const GruShell = ({ indietroA, children }) => {
  const navigate = useNavigate();

  // all'ingresso di una pagina GRU nessun modal può essere aperto: se lo scroll era rimasto bloccato, lo sblocca
  useEffect(() => {
    sbloccaTuttoLoScroll();
  }, []);

  return (
    <ToastProvider>
      <ConfirmProvider>
        <div className="min-h-screen bg-background text-foreground flex flex-col">
          <DashboardHeader />

          <main className="flex-grow w-full relative">
            <div className="w-full max-w-[1600px] mx-auto px-4 sm:px-8 lg:px-12 pt-24 md:pt-32 pb-12 lg:pb-24">
              <div className="flex flex-wrap items-center gap-3 mb-10 animate-in fade-in slide-in-from-left-4 duration-700">
                <button
                  type="button"
                  onClick={() => (indietroA ? navigate(indietroA) : navigate(-1))}
                  className="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-muted/50 hover:bg-muted border border-border/50 transition-all group shadow-sm"
                >
                  <Icon name="ArrowLeft" size={18} className="group-hover:-translate-x-1 transition-transform" />
                  <span className="text-[10px] font-black uppercase tracking-widest">Indietro</span>
                </button>

                <button
                  type="button"
                  onClick={() => navigate('/acv-home')}
                  className="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-primary/10 hover:bg-primary/20 border border-primary/20 transition-all group text-primary shadow-sm shadow-primary/5"
                >
                  <Icon name="Home" size={18} />
                  <span className="text-[10px] font-black uppercase tracking-widest">Dashboard</span>
                </button>
              </div>

              {children}
            </div>
          </main>

          <OrizonFooter />
        </div>
      </ConfirmProvider>
    </ToastProvider>
  );
};

export default GruShell;
